export const juniorCustomerSupportResume = `
【職務概要】
カスタマーサポート業務において約3年の経験を持ち、特にITサービスやSaaSプロダクトに関する技術的サポートを得意としています。電話・メール・チャットサポートを通じた顧客満足度向上に注力し、問い合わせ対応時間の短縮や一次解決率の向上に貢献してきました。お客様からの多岐にわたる技術的質問に対して、的確な回答を提供するとともに、サポートナレッジの蓄積・改善にも積極的に取り組んでいます。

顧客視点での課題解決を常に心がけ、複雑な問題を簡潔に説明するコミュニケーション能力を強みとしています。また、チケット管理システムやCRM、チャットボットなどの最新サポートツールにも精通しており、これらを活用した業務効率化と顧客体験の向上を実現しています。今後はAIを活用したカスタマーサポートの高度化に関心を持ち、技術的知識をさらに深めながら、企業と顧客をつなぐ重要な架け橋としての役割を果たしていきたいと考えています。

【職務経歴】
・株式会社Algomaticソリューションズ（2023年4月〜現在）
  ○ 会社概要：BtoBソフトウェア開発企業、従業員250名、BI/データ分析ツールの開発・販売
  ○ 就業期間：2023年4月〜現在
  ○ 職務内容：テクニカルサポートエンジニア
    - 自社開発のデータ分析ツールに関する技術的問い合わせ対応（電話・メール・チャット）
    - ナレッジベースの作成・管理・更新（月間10件以上の記事作成）
    - 顧客環境での問題切り分けおよびトラブルシューティング
    - 担当製品の機能改善提案（四半期ごとに5件以上の改善提案）
    - 新人サポートスタッフへの研修サポート
  ○ 成果：
    - 平均対応時間を前年比15%短縮（1件あたり35分→30分）
    - 一次解決率の向上（72%→85%）
    - カスタマーサクセスチームと連携し、ユーザーの利用継続率向上に貢献
    - ナレッジベースの拡充により、顧客からの同様の問い合わせ数を月間20件削減
  ○ 使用ツール：Zendesk、Salesforce、Slack、Notion、SQL、Chrome DevTools

・株式会社Algomaticテクノロジー（2021年10月〜2023年3月）
  ○ 会社概要：クラウドサービス提供企業、従業員100名、SaaS型顧客管理システムの開発・販売
  ○ 就業期間：2021年10月〜2023年3月
  ○ 職務内容：カスタマーサポート担当
    - 自社SaaSプロダクトに関する問い合わせ対応（主にメール・チャット）
    - FAQ・マニュアルの作成と更新
    - ユーザーからの機能要望の集約と開発部門への橋渡し
    - 新機能リリース時の社内勉強会運営
  ○ 成果：
    - 顧客満足度調査で平均4.7/5.0のスコア獲得
    - チャットボット導入プロジェクトに参加し、基本的な問い合わせの自動化を実現
    - FAQ拡充により自己解決率が15%向上
  ○ 使用ツール：Intercom、Jira、Confluence、Google Workspace

・株式会社Algomatic産業（2020年4月〜2021年9月）
  ○ 会社概要：ECサイト運営会社、従業員50名、ファッションアイテムのオンライン販売
  ○ 就業期間：2020年4月〜2021年9月
  ○ 職務内容：カスタマーサービス担当
    - 注文・配送・返品に関する問い合わせ対応（電話・メール）
    - 顧客情報管理と購入履歴の分析
    - 顧客の声を商品開発チームにフィードバック
  ○ 成果：
    - 平均応答時間を24時間以内に短縮（以前は48時間）
    - 顧客からのクレーム件数を月間15%削減
    - 顧客の声をもとにした商品改善提案が3件採用
  ○ 使用ツール：カスタム顧客管理システム、Helpscout、Excel

【受賞・表彰歴】
・2023年度 株式会社Algomaticソリューションズ 「クォーターMVP」受賞（2023年7-9月期）
  顧客満足度の向上と効率的な問題解決により、四半期ベストサポートスタッフとして表彰
・2022年度 株式会社Algomaticテクノロジー 「ベストナレッジコントリビューター賞」受賞
  社内ナレッジベース構築への貢献が評価され表彰

【資格】
・ITパスポート（2020年6月取得）
・Zendesk Customer Service Certification（2023年5月取得）
・Google Analytics 個人認定資格（2022年3月取得）
・TOEIC 780点（2021年12月取得）

【マネジメント経験】
・株式会社Algomaticソリューションズにて新入社員2名のメンター担当（2023年7月〜12月）
  ○ オンボーディング計画の作成と実施
  ○ 週次の1on1ミーティングによる業務サポートと課題解決
  ○ 技術的なサポートスキル向上のための指導
  ○ メンティの両名が3ヶ月後に独立して対応可能なレベルまで成長

【語学力】
・英語：ビジネスレベル（TOEIC 780点）
  ○ 海外顧客からの英語での問い合わせ対応が可能
  ○ 技術的な内容について英語での説明・ドキュメンテーションが可能
  ○ 英語の技術ドキュメントやリリースノートの理解と社内展開
 ` as const;
